import { getVmDetails } from '../lib/general';
import { useAppStore } from './useAppStore';

export const useVmFeatures = () => {
    const vm = useAppStore((s) => s.vm);

    // Delegated rather than re-derived: getVmDetails is the single place allowed
    // to decide what the machine's raw flags mean. These two used to repeat its
    // `=== 1` rule here, and three screens used Boolean(...) for the same fields —
    // one rule now, in one place.
    const { hasFiscalReceipt, isFeedbackEnabled } = getVmDetails(vm);

    const showReceiptGlobal = hasFiscalReceipt ?? false;
    const showFeedbackGlobal = isFeedbackEnabled ?? false;

    return {
        showReceiptGlobal,
        showFeedbackGlobal,
    };
};
